// extracted by mini-css-extract-plugin
export default {"list":"list-kZf2n6GaiUO1zsVqfOWp"};